ui-cms-list {
  display: block;
  container-type: inline-size;

  .columns {
    display: grid;
    grid-gap: $sd-spacing-4;

    ol {
      &.sd-list {
        + .sd-list {
          counter-reset: none;
        }
      }
    }

    &.columns-2 {
      @container (min-width: 414px) {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    &.columns-3 {
      @container (min-width: #{$small}) {
        grid-template-columns: repeat(3, 1fr);
      }
    }
  }
}
